import { API } from '@/shared/api';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent } from '../types';

export const DOWNLOAD_CONTENT: LimitedFeatureContent = {
  trial: {
    title: '',
    bulletsHeader: '',
    buttonText: '',
    checkIsSpaceOwner: false,
    features: [],
    // Never rendered: UpgradePlanModal sends downloads straight to TrialPaywall.
    media: { src: '', type: 'image' },
    mixpanelButtonClickEvent: () => MixpanelEvents.viewPlanPaywallClick(),
    mixpanelOpeningEvent: () => {
      MixpanelEvents.paywallOpened();
      void API.sendActivitySignal('paywall_opened');
    },
    subtitle: '',
  },
};
